var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.channelItems,"label":_vm.$t('channels.title'),"dense":"","disabled":""},model:{value:(_vm.channelId),callback:function ($$v) {_vm.channelId=$$v},expression:"channelId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }